export default function useBuildingName(property: string) {
  let data = property.split(",");
  if (data && data.length > 1) {
    return data[1];
  } else if (data && data.length > 0) {
    // flat, apt, room, unit
    let checkingList = ['apartment', 'flat', 'unit', 'room', '/'];
    const match = checkingList.filter(item => data[0].toLowerCase().indexOf(item) > -1);
    return match.length > 0 ? data[0].trim() : "";
  } 
  return "";
}
